import { sortLeftRightTopBottom } from "../../refractCommon/miro/sortLeftRightTopBottom";

export function runFilterOrderValidateSelectedItems(selection, validTypes) {
  let filteredOrderedValidSelection = selection.filter((item) =>
    validTypes.includes(item.type)
  );
  let orderedFilteredSelection = sortLeftRightTopBottom(
    filteredOrderedValidSelection
  );

  return orderedFilteredSelection;
}


